import React from "react";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"
const EmploymentPage = ({
  employment,
  updateEmployment,
  employmentError,

  openDropdown,
  setOpenDropdown,

  LOAN_PURPOSES,
  EMPLOYMENT_TYPES,
  SALARY_MODES,

  FwDayCalendar,
  FwDropdown,

  setScreen,
  submitEmployment,
}) => {
  return (
    <section className="fw-screen fw-screen--form fw-fade">
           <div className="fw-brandmain">
          <img 
            src={fundwalelogo} 
            alt="Fundswalle" 
            className="fw-brand__logo1" 
          />
        </div>
      <h1 className="fw-title">Employment Details</h1>

      <label className="fw-field">
        <span>Name of Employer</span>

        <input
          value={employment.employer}
          placeholder="Reliance Industries Ltd."
          onChange={(e) =>
            updateEmployment(
              "employer",
              e.target.value
            )
          }
        />
      </label>

      <label className="fw-field">
        <span>Net Monthly Salary (₹)</span>

        <input
          inputMode="numeric"
          value={employment.salary}
          placeholder="eg. 30,000"

          onChange={(e) => {
  const salary = e.target.value
    .replace(/\D/g, "")
    .slice(0, 8);

  updateEmployment("salary", salary);
}}
        />
        {employment.salary &&
  Number(employment.salary) < 20000 && (
    <p className="fw-error">
      Net monthly salary must be at least ₹20,000
    </p>
  )}
      </label>

      <FwDayCalendar
        id="salaryDate"
        label="Salary Date"
        value={employment.salaryDate}
        placeholder="Select date (DDMMYY)"
        openKey={openDropdown}
        setOpenKey={setOpenDropdown}
        onChange={(val) =>
          updateEmployment("salaryDate", val)
        }
      />

      <label className="fw-field">
        <span>Loan Amount Required (₹)</span>

        <input
          inputMode="numeric"
          value={employment.loanAmount}
          placeholder="eg. 50,000"
          onChange={(e) =>
            updateEmployment(
              "loanAmount",
              e.target.value
                .replace(/\D/g, "")
                .slice(0, 7)
            )
          }
        />
      </label>

      <FwDropdown
        id="loanPurpose"
        label="Loan Purpose"
        value={employment.loanPurpose}
        placeholder="Select loan purpose"
        options={LOAN_PURPOSES}
        openKey={openDropdown}
        setOpenKey={setOpenDropdown}
        onChange={(val) =>
          updateEmployment("loanPurpose", val)
        }
      />

      <FwDropdown
        id="employmentType"
        label="Employment Type"
        value={employment.employmentType}
        placeholder="Select employment type"
        options={EMPLOYMENT_TYPES}
        openKey={openDropdown}
        setOpenKey={setOpenDropdown}
        onChange={(val) =>
          updateEmployment("employmentType", val)
        }
      />

      <FwDropdown
        id="salaryMode"
        label="Salary Received via"
        value={employment.salaryMode}
        placeholder="Select mode of income"
        options={SALARY_MODES}
        openKey={openDropdown}
        setOpenKey={setOpenDropdown}
        onChange={(val) =>
          updateEmployment("salaryMode", val)
        }
      />

      {/* {employmentError && (
        <p className="fw-error">
          {employmentError}
        </p>
      )} */}

      <div className="fw-actions">
        <button
          type="button"
          className="fw-btn fw-btn--ghost"
          onClick={() => setScreen("/apply-new/aadhaarKyc")}
        >
          Back
        </button>

        <button
          type="button"
          className="fw-btn fw-btn--primary"
          onClick={submitEmployment}
            disabled={
    !employment.salary ||
    Number(employment.salary) < 20000
  }
        >
          Proceed
        </button>
      </div>
    </section>
  );
};

export default EmploymentPage;